import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'ml.quoteandbind.hobbyFarm.address',
        defaultMessage: 'Address'
    },
    propertyDescription: {
        id: 'ml.quoteandbind.hobbyFarm.propertyDescription',
        defaultMessage: 'Description of Property'
    },
    annualIncome: {
        id: 'ml.quoteandbind.hobbyFarm.annualIncome',
        defaultMessage: 'Gross Annual Income from Farm/Ranch'
    },
    publicAccess: {
        id: 'ml.quoteandbind.hobbyFarm.publicAccess',
        defaultMessage: 'Public Access'
    },
    anyEmployees: {
        id: 'ml.quoteandbind.hobbyFarm.anyEmployees',
        defaultMessage: 'Any Employees'
    },
    numberOfAcres: {
        id: 'ml.quoteandbind.hobbyFarm.numberOfAcres',
        defaultMessage: 'Number of Acres'
    },
    rentedOrLeased: {
        id: 'ml.quoteandbind.hobbyFarm.rentedOrLeased',
        defaultMessage: 'Is any land rented/leased for hunting or commercial farming?'
    },
    isADwellingOnLand: {
        id: 'ml.quoteandbind.hobbyFarm.isADwellingOnLand',
        defaultMessage: 'Is a Dwelling on the land?'
    },
    isFullTimeOccupation: {
        id: 'ml.quoteandbind.hobbyFarm.isFullTimeOccupation',
        defaultMessage: "Is Insured's full-time occupation farming?"
    },
    action: {
        id: 'ml.quoteandbind.hobbyFarm.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.hobbyFarm.modalTitle',
        defaultMessage: 'Add Liability Coverage for Hobby Farm - Off Site'
    },
    addressLine1: {
        id: 'ml.quoteandbind.hobbyFarm.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.hobbyFarm.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.hobbyFarm.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.hobbyFarm.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.hobbyFarm.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.hobbyFarm.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.hobbyFarm.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.hobbyFarm.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.hobbyFarm.continueBtn',
        defaultMessage: 'Continue'
    },
});
